import * as React from 'react';

import FileDocs32 from './FileDocs32';

export const fileDocs32 = () => <FileDocs32 />;

export default {
    title: 'Icon|Content|FileDocs32',
    component: FileDocs32,
    parameters: {
        notes: "`import FileDocs32 from 'box-ui-elements/es/icon/content/FileDocs32';`",
    },
};
